import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Container, Modal, Row } from 'react-bootstrap'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';
import { useReactToPrint } from "react-to-print";
import { toast, ToastContainer } from "react-toastify";

import Table from "../components/Table/Table"
import axios from 'axios';
import bank from "../assets/bank.png"
import cash from "../assets/money.png"
import CustomBtn from '../components/CustomBtn/CustomBtn';
import { useParams } from 'react-router-dom';

function AdminStudentFinance() {
  const { id } = useParams()
  const { gradId } = useParams()
const printRef = useRef();
  const { currentLocal } = useSelector((state) => state.currentLocal);
  const userinfo = useSelector((state) => state.auth);
  const inputRef = useRef(null);
  const [updatedPayments, setUpdatedPayments] = useState([])
  const [loading, setLoading] = useState(false);
  const [show, setShow] = React.useState(false);
  const [state, setstate] = useState(0)
  const [statex, setState] = useState('')
  const [file, setFile] = useState(null);
  const [selectedId, sseSelectedId] = useState('');

  const handleClose = () => setShow(false);
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const [items, setItems] = useState([]);
  useEffect(() => {
    const getFinance = async () => {
      await axios
        .post(`https://nanosoft.space/taarteb/public/api/user/auth/me`, {}, {
          headers: {
            Authorization: `Bearer ${userinfo.userArray.access_token}`
          }
        })
        .then(async (res) => {




          setUpdatedPayments(res.data.data)

        })
        .catch((error) => {





        });
      try {


        const response = await axios.get(userinfo?.userArray?.user?.role == "School Manager" ? `https://nanosoft.space/taarteb/public/api/admin/student-expenses` : `https://nanosoft.space/taarteb/public/api/student/expenses`,

          {
            headers: {
              Authorization: `Bearer ${userinfo.userArray.access_token}`,
            },
          }
        );
        console.log(response.data.data);


        //         const updatedData = response.data.data.map(item => ({
        //   ...item,
        //   status: item.status == null ? "pinding": item.status,
        //   pay_date:item.pay_date==null?"_________":item.pay_date
        // }));
        console.log(response.data.data,"response.data.data");
        const studentsData = [...response.data.data.student_expenses?.data, ...response.data.data.recently_created_students]
        console.log(studentsData, "1111");
        const studentData = studentsData.filter((item) => {
          const studentId = item?.student?.id || item?.id;
          return String(studentId) === String(id);
        })
        console.log(studentData, "2222");

        // const filterData=response.data.data.find((item)=>item?.grade_id==gradId)

        setItems(studentData)
        // setItems(userinfo?.userArray?.user?.role == "School Manager" ?studentData:response.data.data)
      } catch (error) {
        console.log(error);

      }

    }
    getFinance()
  }, [])

    const printTable = () => {
        const content = document.getElementById("financialTable").innerHTML;

        const printWindow = window.open("", "_blank", "width=900,height=700");
        printWindow.document.write(`
    <html dir="rtl">
      <head>
        <title>${currentLocal.home.FinanceReport}</title>
        <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css">
        <style>
          body {
            font-family: Arial, sans-serif;
            direction: rtl;
            padding: 20px;
          }
          .fw-bold {
            font-weight: bold;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 20px;
          }
          table, th, td {
            border: 1px solid #000;
          }
          th, td {
            padding: 8px;
            text-align: center;
          }
          th {
            background-color: #f8f8f8;
          }
        </style>
      </head>
      <body>
        ${content}
      </body>
    </html>
  `);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };
  const headerIterm =
    localStorage.getItem("type") === "sales"
      ? [
        currentLocal.home.namePlaceholder,
        currentLocal.home.phone,
        currentLocal.home.Total,
        currentLocal.home.PaidPrice,
        currentLocal.home.RemainingPrice,
        state.value === 0 ? currentLocal.home.Installments : null,
        currentLocal.home.method,
        currentLocal.home.paymentdate,

        currentLocal.home.status,
      ]
      : [
        state.value === 0 ? currentLocal.home.title : currentLocal.home.name,
        currentLocal.home.ID,
        currentLocal.home.Academicyear,
        currentLocal.home.stageName,
        currentLocal.home.grade,

        currentLocal.home.price,
        currentLocal.home.priceTotal,

        // currentLocal.home.Total,
        // currentLocal.home.Lastpaymentdate,
        currentLocal.home.method,

        currentLocal.home.paymentdate,
        currentLocal.home.status,
      ];




  const body = <tbody>
    {items?.map((item, index) => {

      return (
        <tr key={index}>

          <td>{item?.id}</td>
          <td><img src={item?.receipt} alt='' className='w-25' /></td>
          {item?.payment_method && <td>{item.payment_method == "1" ? currentLocal.home.Cash : currentLocal.home.visa}</td>}
          <td>{item?.amount_paid}{" "}{currentLocal.home.currancy}</td>
          <td>{item?.created_at.slice(0,10)}</td>
 <td>{item.status=="accepted"?currentLocal.home.accept:item.status=="pending"?currentLocal.home.pending:currentLocal.home.reject}</td>


        </tr>
      )
    })}

  </tbody>
const item = items?.[0];
console.log(item);

const total = item?.exception_price ?? item?.price ?? item?.expense_price;
const paid = item?.cumulative_paid ?? 0;
const remaining = item?.exception_price
  ? Number(item?.exception_price) - Number(paid)
  : item?.amount_due;  
  return (
    <div className="px-0 my-3 w-100 student_finance_content">
      <ToastContainer />
      <Modal show={show} onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >

        <Modal.Body>
          <div className="w-100 d-flex justify-content-center">
            <div className="login_form_section_container w-100 d-flex flex-column pt-3  align-items-center"
              style={{ cursor: "pointer" }}

            >
              <p className='fw-bold mb-4 text-center'>{currentLocal.home.Pleasepaytheregistrationformfee}  </p>
              <h5 className='fw-bold'>{currentLocal.home.Chooseapaymentmethod} </h5 >
              <div className='d-flex'>
                {userinfo?.userArray?.user?.role!=="Student"&&
               <div
                  className='d-flex flex-column mt-3 align-items-center  py-3 px-1 mx-2'
                  onClick={() => setState("cash")}
                  style={{
                    border: statex == "cash" ? "1px solid #e63967" : "1px solid #dee2e6"
                  }}
                >
                  <img src={cash} alt="" className="w-25" />

                  <p className='fs-6'>
                    {currentLocal.home.Cash}
                  </p>
                </div> 
}
                <div
                  className='d-flex flex-column mt-3 align-items-center  py-3 px-1 '
                  style={{
                    border: statex == "bank" ? "1px solid #e63967" : "1px solid #dee2e6",
                    cursor: "pointer"
                  }}
                  onClick={() => setState("bank")}
                >
                  <img src={bank} alt="" className="w-25" />
                  <p className='fs-6'>
                    {currentLocal.home.bankAccount}
                  </p>
                </div>
              </div>
              {statex == "bank" ?
                <div>
                  <h6 className='mt-3'>{currentLocal.home.Pleasesendtheformfeetomyaccount} </h6>
                  <p className='mb-1 text-center'>0429004961810012</p>
                  <p className='fw-bold text-center'>بنك مسقط</p>
                  <p>{currentLocal.home.Pleasesendthereceipt}</p>
                  <div>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      accept="image/*"
                      ref={inputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    {/* Custom button to trigger file input */}
                    <div
                      style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                      onClick={() => inputRef.current.click()}
                    >
                      {file ?
                        <div className='h-100'>
                          <img
                            src={URL.createObjectURL(file)}
                            alt="preview"
                            style={{ height: "100%", width: "100%", objectFit: "contain" }}
                          />
                        </div>
                        :
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                          </svg>
                        </>
                      }

                    </div>



                  </div>



                </div>
                :
                <>
                  <p className='mt-4'>{currentLocal.home.Pleasesendthereceipt}</p>
                  <div>

                    {/* Hidden file input */}
                    <input
                      type="file"
                      accept="image/*"
                      ref={inputRef}
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />

                    {/* Custom button to trigger file input */}
                    <div
                      style={{ border: "1px dashed #000", height: "150px", justifyContent: "center", alignItems: "center", display: "flex", width: "350px", }}
                      onClick={() => inputRef.current.click()}
                    >
                      {file ?
                        <div className='h-100'>
                          <img
                            src={URL.createObjectURL(file)}
                            alt="preview"
                            style={{ height: "100%", width: "100%", objectFit: "contain" }}
                          />
                        </div>
                        :
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="gray" className="bi bi-image" viewBox="0 0 16 16">
                            <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                            <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
                          </svg>
                        </>
                      }

                    </div>



                  </div>
                </>
              }
              <div className='mt-4 w-100 '>
                <div className='d-flex  justify-content-center align-items-center'>
                  <CustomBtn text={loading ? currentLocal.home.Loading : currentLocal.home.send} disabled={loading} type={"submit"} clickingFunction={async () => {
                    if (!file) {
                      alert("Please select an image first!");
                      return;
                    }

                    const formData = new FormData();
                    formData.append("image", file);
                    setLoading(true)
                    const body = userinfo?.userArray?.user?.role == "School Manager" ? {
                      student_id: id,
                      payment_method: statex == "cash" ? 1 : 2,
                      receipt: file,
                      expense_id: selectedId

                    } : {
                      payment_method: statex == "cash" ? 1 : 2,
                      receipt: file,
                      expense_id: selectedId

                    }
                    try {
                      const res = await axios.post(userinfo?.userArray?.user?.role == "School Manager" ? `https://nanosoft.space/taarteb/public/api/admin/student-expenses` : "https://nanosoft.space/taarteb/public/api/student/expenses", body, {
                        headers: {
                          "Content-Type": "multipart/form-data",
                          Authorization: `Bearer ${userinfo?.userArray.access_token}`,

                        },
                      });
                      setLoading(false)

                      toast.success(currentLocal.home.successSuccessfully, { position: "bottom-right", autoClose: 3000 });
                      setTimeout(() => {
                        setShow(false)

                      }, 3000);

                    } catch (error) {
                      setLoading(false)
                      toast.error(Object.values(error.response.data.errors)[0][0], { position: "bottom-right", autoClose: 3000 });

                    }
                  }} />

                </div>
              </div>

              {/* <SignupForm/> */}
            </div>
          </div>
        </Modal.Body>

      </Modal>
      <Container>
        <div className="d-flex flex-column w-100">
          <AuthNavbar />
          <div className="mt-5 mx-3">
            <HomeTitle title={currentLocal.home.Academicyearexpenses} />
            {updatedPayments?.user?.student?.is_fee_paid == 0 ?
              <div className='h-100 w-100 d-flex justify-content-center  align-items-center'>
                <p className='fw-bold text-danger'>يرجي انتظار المدرسة قبول طلب الالتحاق</p>
              </div>
              :
              <div               
>
                <div >
                  <button onClick={printTable} className="btn  border mb-3 mt-3">
                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" className="bi bi-printer" viewBox="0 0 16 16">
                      <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                      <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                    </svg>
                  </button>
                </div>
                <div id={"financialTable"}>

                <Row className='mb-5'>
<h5>{currentLocal.home.nameStudent} : {items?.[0]?.student?.name}</h5>
                  {/* {localStorage.getItem("type") == "sales" &&
                    <Col md={3}>
                      <Select
                        value={grade_id}
                        onChange={(selectedOption) => setGrade_id(selectedOption)}
                        options={yearoptions}
                        placeholder={currentLocal.home.Selectyear} // Change this text

                      />
                    </Col>
                  } */}
                  {/* <Col md={3}>
                <Select
                  value={grade_id}
                  onChange={(selectedOption) => setGrade_id(selectedOption)}
                  options={options}
                  placeholder={currentLocal.home.stageName} // Change this text

                />
              </Col> */}
                  {/* <Col md={3}>
                <Select
                  value={type_id}
                  onChange={(selectedOption) => setType_id(selectedOption)}
                  options={gradoptions}
                  placeholder={currentLocal.home.grade} // Change this text

                />
              </Col> */}
                  {/* <Col md={3}>
                <Select
                  value={state}
                  onChange={(selectedOption) => setstate(selectedOption)}
                  options={classoptions}
                  placeholder={currentLocal.home.method} // Change this text

                />
              </Col> */}
                </Row>
                <Row>
                  <Col md={6}>
        <p>{currentLocal.home.Total} : {total} {currentLocal.home.currancy}</p>
    <p>{currentLocal.home.PaidPrice} : {paid} {currentLocal.home.currancy}</p>
    <p>{currentLocal.home.RemainingPrice} : {remaining} {currentLocal.home.currancy}</p>

                    {/* <p>  {item?.grade_name} , {item?.grade_category_name} ({item?.year})</p> */}
                    {/*  {item?.exceptions_price != null &&
                            <>
                              <p>{currentLocal.home.Exceptions} : {item?.exceptions_price}</p>
                              <p>{item?.exceptions_notes}</p>
                            </>
                          } */}
                  </Col>
                  <Col md={6}>
                    <div className='d-flex justify-content-end'>
                      {(Number(items?.[0]?.amount_due) !== 0 || items?.[0]?.expense_price === null) && (
                        <Button variant="success" onClick={() => {

                          setShow(true);
                          sseSelectedId(items?.id)
                        }}>
                          {currentLocal.home.payNow}
                        </Button>
                      )}
                    </div>
                  </Col>
                </Row>
                {/* {items?.data?.map((item) => {
                  console.log(item,"item");

                  return (
                    <>
            
                      <div id="financialTable">
                        <Table
                          data={items?.data}
                          dataID={item?.id}
                          headerIterm={[
                            currentLocal.home.ID,
                            currentLocal.home.image,
                            currentLocal.home.method,
                            currentLocal.home.PaidPrice,
                            //  currentLocal.home.RemainingPrice,
                            currentLocal.home.date,
                            currentLocal.home.status,



                          ].filter(Boolean)}
                        // actions={["acceptOrReject"]}

                        // onDataChanged={getAllApis}
                        />
                      </div>
                    </>
                  )
                })} */}
<div >

                <Table
                  body={body}
                  headerIterm={[
                    currentLocal.home.ID,
                    currentLocal.home.image,
                    currentLocal.home.method,
                    currentLocal.home.PaidPrice,
                    //  currentLocal.home.RemainingPrice,
                    currentLocal.home.date,
                    currentLocal.home.status,



                  ].filter(Boolean)}
                // actions={["acceptOrReject"]}

                // onDataChanged={getAllApis}
                />
                </div>
                </div>
              </div>
            }



          </div>

        </div>
      </Container>
    </div>)
}

export default AdminStudentFinance